module.exports = "<p>\n  telugu works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/Guest/Desktop/meme/src/app/telugu/telugu.component.html
// module id = ../../../../../src/app/telugu/telugu.component.html
// module chunks = main